<template><SimpleModuleDashboard :module-id="Modules.CLIENTES" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" :widget-filter="filterWidgets" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    validEmailRepeat: Helper.hasParametersAccess(Param.P32),
    actions: [{ id: 'crud', reference: 'crud', route: 'CustomerListStaff', tone: 'primary' }],
  }),
  methods: {
    filterWidgets(widget) {
      return widget.reference !== 'list_customers_email_repeat' || this.validEmailRepeat
    },
  },
}
</script>
